import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Isolates toast rendering errors so a broken toast cannot
 * unmount the rest of the React tree (white screen).
 */
export class ToastErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error("[ToastErrorBoundary] Toast subtree crashed:", error, info);
  }

  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}
